(() => {
  const slots = [...document.querySelectorAll('[data-card-brand]')];

  const normalize = name => String(name || '').trim().toLocaleLowerCase('es');
  window.kleverPortalFetch('https://portal.klever-shop.cl/api/public/brands', { headers: { Accept: 'application/json' }, cache: 'no-store' })
    .then(response => response.json())
    .then(({items = []}) => {
      const brands = new Map(items.filter(brand => brand.logoUrl).map(brand => [normalize(brand.name), brand]));
      const apply = () => document.querySelectorAll('[data-card-brand]:not([data-logo-loaded])').forEach(slot => {
        const brand = brands.get(normalize(slot.dataset.cardBrand));
        if (!brand) return;
        const logo = new Image();
        logo.alt = slot.dataset.cardBrand;
        logo.width = 90;
        logo.height = 26;
        logo.className = 'kb-brand__logo';
        logo.onload = () => slot.replaceChildren(logo);
        slot.dataset.logoLoaded = 'true';
        logo.src = brand.logoUrl;
      });
      apply();
      document.addEventListener('klever:products-added', apply);
      document.querySelectorAll('[data-klever-related-grid]').forEach(grid => new MutationObserver(apply).observe(grid, {childList:true}));
    }).catch(() => { /* Retain the brand name if its logo is unavailable. */ });
})();
